"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Star } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
const testimonials = [{
  id: 1,
  author: "Marco R.",
  quote: "The Al Pastor tacos are life-changing. Best street food I've had since Mexico City!",
  position: "Local Foodie",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685947/img/taco_fan_marco.png"
}, {
  id: 2,
  author: "Sarah L.",
  quote: "Rolling Tacos brought the heat to our block party. The habanero salsa is no joke!",
  position: "Event Organizer",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1685947/img/taco_fan_sarah.png"
}];
export default function StreetCred() {
  return <section data-section-id="235824" id="street-cred" className="bg-background text-foreground relative py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none overflow-hidden">
        <span className="text-[200px] font-default text-primary opacity-10 leading-none transform -translate-x-1/2 -translate-y-1/4">
          &ldquo;
        </span>
        <span className="text-[200px] font-default text-primary opacity-10 leading-none transform translate-x-1/2 translate-y-1/4">
          &rdquo;
        </span>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-5xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={testimonial.id} data-index={i}>
                <div className="flex flex-col items-center text-center space-y-10 p-6 md:p-12">
                  <p className="text-3xl md:text-5xl font-serif italic leading-relaxed text-foreground tracking-tight max-w-4xl">
                    "{testimonial.quote}"
                  </p>

                  <div className="flex flex-col items-center space-y-6">
                    <div className="flex space-x-1.5 text-primary">
                      {[...Array(5)].map((_, starIdx) => <span key={starIdx} data-index={starIdx}>
                          <Star className="w-6 h-6 fill-current" />
                        </span>)}
                    </div>

                    <div className="flex items-center space-x-4">
                      <SafeHydrate><Avatar className="w-14 h-14 border-2 border-primary shadow-lg shadow-primary/20 rounded-md">
                        <AvatarImage src={testimonial.avatar} alt={testimonial.author} />
                        <AvatarFallback className="font-mono bg-secondary text-secondary-foreground rounded-md">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="text-left">
                        <div className="font-mono font-bold text-lg tracking-tighter text-primary">
                          @{testimonial.author.toUpperCase()}
                        </div>
                        <div className="text-sm text-muted-foreground font-medium uppercase tracking-widest">
                          {testimonial.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </CarouselItem>)}
          </CarouselContent>
          <CarouselPrevious className="hidden md:flex -left-4 lg:-left-12 bg-background border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all rounded-md shadow-md" />
          <CarouselNext className="hidden md:flex -right-4 lg:-right-12 bg-background border-2 border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-all rounded-md shadow-md" />
        </Carousel>
      </div>
    </section>;
}